/**
 * The door to `graph.ts` that route files are allowed to walk through.
 *
 * `graph.ts` statically imports the glossary and guide registries, which carry
 * their English bundles, so a route that imported it at the top would put all
 * of that prose into the tool page's chunk. This module imports it only
 * dynamically — it is the one static import a route may take — so the derived
 * links cost a separate, cached chunk and nothing else. See `graph.ts`.
 */

import type { ContentLang } from "@fazly/shared/contentLang";

import type { ToolLink } from "./graph";
import type { ToolSlug } from "./tools/types";

export type { ToolLink };

/**
 * Every term and guide that names `tool`, for a route loader. Never throws.
 *
 * These links decorate the page; they must not be able to take it down. A
 * chunk that fails to load on a client-side navigation — a deploy between two
 * clicks, a flaky connection — would otherwise turn a tool page into an error
 * page over its "read more" list. House rule 6, applied to our own code.
 */
export function loadToolLinks(
  tool: ToolSlug,
  lang: ContentLang,
): Promise<ToolLink[]> {
  return import("./graph").then((m) => m.toolLinks(tool, lang)).catch(() => []);
}
